import { render, staticRenderFns } from "./PageCoverConfigForm.vue?vue&type=template&id=1b88e260"
import script from "./PageCoverConfigForm.vue?vue&type=script&lang=js"
export * from "./PageCoverConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports